import { Children, Fragment, ReactNode } from 'react';
import { Carousel } from '@consumidor-positivo/aurora';


import './styles.scss';

type FeaturedOffersCarouselProps = {
  children: ReactNode | ReactNode[];
};

export function FeaturedOffersCarousel({ children }: FeaturedOffersCarouselProps) {
  const wrappedChildren =
    Children.map(children, (child, index) => {
      return <Fragment key={index}>{child}</Fragment>;
    }) || [];

  return (
    <div className="offers-featured__carousel">
      <div className="offers-featured__carousel-wrapper">
        <Carousel type="pages" draggable={false} items={wrappedChildren} />
      </div>
    </div>
  );
}
